import React from 'react';
import { DragDropContext, OnDragEndResponder } from 'react-beautiful-dnd';
import { useAppDispatch } from '../../../../redux/hooks';
import { swapDataTableMeasure } from '../../../../redux/slices/oldBuilder';
import * as BuilderUI from '../../../../components/Builder/BuilderUI';
import SectionHeading from '../../../../components/SectionHeading';
import { dataTableMeasureInfo } from '../../../../components/KubitTooltip/globalTooltips';
import { AliasHighlight } from '../../../../components/Builder/AliasNavigation/AliasHighlight';
import ReportFilter from '../../../../components/Builder/ReportFilter';
import Breakdown from '../../../../components/Builder/Breakdown';
import DataTableMeasures from './DataTableMeasures';
import DataTableBuilderHeader from './DataTableBuilderHeader';
import BuilderExecutionDateRange from '../../../../components/Builder/BuilderExecutionDateRange';
import ExecuteReport from '../../../../components/Builder/ExecuteReport';
import ComparisonConfigPicker from '../../Query/QueryBuilder/QueryDateRangeSettings/ComparisonConfigPicker';
import useBuilderSelector from '../../../../redux/selectorHooks/useBuilderSelector';
import useShowCloseLlmPrompt from '../../../../components/Builder/LlmPrompt/useShowCloseLlmPrompt';
import LlmPrompt from '../../../../components/Builder/LlmPrompt';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';

const DataTableBuilder = () => {
  const dispatch = useAppDispatch();
  const compoundMeasureUserAliasId = useBuilderSelector(
    'compoundMeasureUserAliasId',
  );

  const onDragEnd: OnDragEndResponder = (result) => {
    if (!result || !result.source || !result.destination) {
      return;
    }

    dispatch(
      swapDataTableMeasure({
        sourceIndex: result.source.index,
        targetIndex: result.destination.index,
      }),
    );
  };

  const { showLlmPrompt, handleCloseLlmPrompt } = useShowCloseLlmPrompt();

  return (
    <>
      <DataTableBuilderHeader />
      {showLlmPrompt && (
        <LlmPrompt
          queryType={QueryType.DataTable}
          onClose={handleCloseLlmPrompt}
        />
      )}
      <BuilderUI.Part1>
        <SectionHeading
          heading="Measure(s)"
          tooltipOption={dataTableMeasureInfo}
        />
        <AliasHighlight aliasId={compoundMeasureUserAliasId}>
          <DragDropContext onDragEnd={onDragEnd}>
            <DataTableMeasures />
          </DragDropContext>
        </AliasHighlight>
      </BuilderUI.Part1>
      <BuilderUI.Part2>
        <ReportFilter />
        <BuilderUI.HorizontalDivider />
        <Breakdown showOverall={false} />
        <BuilderUI.HorizontalDivider />
        <BuilderUI.Row>
          <BuilderExecutionDateRange />
          <ComparisonConfigPicker />
        </BuilderUI.Row>
      </BuilderUI.Part2>
      <ExecuteReport />
    </>
  );
};

export default DataTableBuilder;
